import { slicedToArray as _slicedToArray } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useEffect } from 'react';
import { FlexBox, Link, Typography } from '@vp/swan';
import { useTracking } from './QuerySuggestionsSearchInputTrackingProvider.js';
import { useSearchContext } from '../../../searchContext/SearchContextProvider.js';
import { useRecentSearch } from '../../../localStorage/useRecentSearch.js';
import TextWithInverseHighlight from './TextWithInverseHighlight.js';

var QuerySuggestionsRecentSearchItem = function QuerySuggestionsRecentSearchItem(props) {
  var searchItem = props.searchItem,
    trackingEventLabel = props.trackingEventLabel;
  var _React$useState = React__default.useState(undefined),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    destinationUrl = _React$useState2[0],
    setDestinationUrl = _React$useState2[1];
  var _useTracking = useTracking(),
    sendQuerySubmittedEvent = _useTracking.sendQuerySubmittedEvent;
  var _useSearchContext = useSearchContext(),
    resultsPageUrl = _useSearchContext.resultsPageUrl;
  var _useRecentSearch = useRecentSearch(),
    addRecentSearch = _useRecentSearch.addRecentSearch;
  var suggestedQueryItemRightClickHandler = function suggestedQueryItemRightClickHandler(e) {
    sendQuerySubmittedEvent({
      label: trackingEventLabel,
      queryToOverride: searchItem.title
    });
    addRecentSearch(searchItem.title);
  };
  useEffect(function () {
    setDestinationUrl("".concat(resultsPageUrl, "?query=").concat(searchItem.title));
  }, [searchItem.title, resultsPageUrl]);
  return /*#__PURE__*/React__default.createElement(FlexBox, {
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/React__default.createElement(Link, {
    key: "link_".concat(searchItem.objectID),
    skin: 'unstyled',
    href: destinationUrl,
    style: {
      flexGrow: 1
    },
    className: "swan-listbox-option swan-listbox-option-with-thumbnail query-suggestion-item",
    py: 4,
    px: 5,
    onContextMenu: function onContextMenu(e) {
      return suggestedQueryItemRightClickHandler();
    },
    onAuxClick: function onAuxClick(e) {
      return suggestedQueryItemRightClickHandler();
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    visuallyHidden: true
  }, searchItem.title), /*#__PURE__*/React__default.createElement(Typography, {
    "aria-hidden": "true"
  }, /*#__PURE__*/React__default.createElement(TextWithInverseHighlight, {
    resultText: (searchItem === null || searchItem === void 0 ? void 0 : searchItem.highlightResult) || searchItem.title
  }))));
};

export { QuerySuggestionsRecentSearchItem as default };
//# sourceMappingURL=QuerySuggestionsSuggestedQueryItem.js.map
